import { isVoiceConfigurable as checkIsVoiceConfigurable } from '@conversed/shared/src/central/helpers/voice-mode.helper';
import { StudioType } from '@conversed/shared/src/central/types/studio.type';
import { useMemo } from 'react';
import { useCompanySelector } from './useCompanySelector';

// * A Voice A.I. Studio is voice-only by definition, so the webclient voice
// * mode is derived from the studio type rather than stored as a user choice.
export const useVoiceStudio = () => {
  const { selectedCompany } = useCompanySelector();

  const isVoiceOnlyStudio = useMemo(() => {
    if (!selectedCompany) {
      return false;
    }

    return selectedCompany.studioType === StudioType.VOICE_AI;
  }, [selectedCompany]);

  const isVoiceConfigurable = useMemo(() => {
    if (!selectedCompany) {
      return false;
    }

    return checkIsVoiceConfigurable({
      studioType: selectedCompany.studioType,
      platformFeatures: selectedCompany.platformFeatures,
    });
  }, [selectedCompany]);

  return {
    isVoiceOnlyStudio,
    isVoiceConfigurable,
  };
};
